import { Header } from "./components/Header";

export const Dashboard = () => {
  return (
    <div className="position-relative">
      <Header />
    </div>
  );
};
